'use strict';

const options = {
	'12377493': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['缺勤', 'absence from work', '缺勤'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
	},
	'12673852': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
	},
	'54269279': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
	},
	'23420497': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['工時不足', 'Insufficient working hours', '工时不足'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
	},
	'16218320': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
		'am.cardMatch.statusforAm40030Search': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
	},
	'97474448': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['未準時出勤', 'Not on time', '未准时出勤'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
	},
	'00000000': {
		'pb.account.types': {
			'0': ['月結薪資', 'Monthly Salary', '月结薪资'],
			'1': ['獨立發放項目(獎金)', 'Individually Distributed (Bonus)', '独立发放项目(奖金)'],
		}, 
		'pb.account.dc': {
			'1': ['借方', 'Debit', '借方'],
			'2': ['貸方', 'Credit', '贷方'],
		},
	},
	'35882520': {
		'pb.account.types': {
			'0': ['月結薪資', 'Monthly Salary', '月结薪资'],
			'1': ['獨立發放項目(獎金)', 'Individually Distributed (Bonus)', '独立发放项目(奖金)'],
		},
	},
	'22854522': {
		'pb.account.types': {
			'0': ['月結薪資', 'Monthly Salary', '月结薪资'],
			'1': ['獨立發放項目(獎金)', 'Individually Distributed (Bonus)', '独立发放项目(奖金)'],
			'2': ['年獎', '年獎', '年獎'],
		}, 
		'pb.account.dc': {
			'1': ['借方', 'Debit', '借方'],
			'2': ['貸方', 'Credit', '贷方'],
		},
	},
	'50971254': {
		'pb.account.types': {
			'0': ['月結薪資', 'Monthly Salary', '月结薪资'],
			'1': ['獨立發放項目(獎金)', 'Individually Distributed (Bonus)', '独立发放项目(奖金)'],
			'2': ['年獎', '年獎', '年獎'],
		}, 
		'pb.account.dc': {
			'1': ['借方', 'Debit', '借方'],
			'2': ['貸方', 'Credit', '贷方'],
		},
	},
	'04123790': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
		'am.cardMatch.statusforAm40030Search': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
	},
	'24624152': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['請處理', 'Action required', '请处理'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
		'am.cardMatch.statusforAm40030Search': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['請處理', 'Action required', '请处理'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
	},
	'04377371': {
		'pb.account.types': {
			'0': ['月結薪資', 'Monthly Salary', '月结薪资'],
			'1': ['獨立發放項目(獎金)', 'Individually Distributed (Bonus)', '独立发放项目(奖金)'],
		}, 
		'pb.account.dc': {
			'1': ['借方', 'Debit', '借方'],
			'2': ['貸方', 'Credit', '贷方'],
		},
	},
	'84149385': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
		'am.cardMatch.statusforAm40030Search': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
	},
	'90143492': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['考勤異常', 'Attendance Abnormal', '考勤异常'],
			'6': ['考勤異常', 'Attendance Abnormal', '考勤异常'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
		'am.cardMatch.statusforAm40030Search': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['考勤異常', 'Attendance Abnormal', '考勤异常'],
			'6': ['考勤異常', 'Attendance Abnormal', '考勤异常'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
	},
	'93659042': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
		'am.cardMatch.statusforAm40030Search': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
	},
	'22589593': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
		'am.cardMatch.statusforAm40030Search': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		},
	},
	'54662717': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
		'am.cardMatch.statusforAm40030Search': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['異常', 'Abnormal', '异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
	},
	'27896986': {
		'am.cardMatch.status': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['出勤異常', 'Abnormal', '出勤异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
		'am.cardMatch.statusforAm40030Search': {
			'0': ['未比對', 'Unprocessed', '未比对'],
			'1': ['正常', 'Correct', '正常'],
			'2': ['不比對異常', 'Ignore the Exception', '不比对异常'],
			'3': ['遲到', 'Late', '迟到'],
			'4': ['早退', 'Leave Early', '早退'],
			'5': ['出勤異常', 'Abnormal', '出勤异常'],
			'6': ['未打卡', 'No Results', '未打卡'],
			'7': ['加班刷卡時間不足', 'Insufficient Overtime Hours', '加班刷卡时间不足'],
		}, 
	}
};

const sno = (typeof window === 'undefined') ? process.env.SNO : window.sno;

let custOptions = {};
if (sno) {
	try {
		custOptions = require(`../${sno}/constants/options.js`);
	} catch (err) {

	}
}

module.exports = {
	...options[sno],
	...custOptions,
};
